<template>
  <div :ref="guid" class="browser-block" :style="myBlockProps.getStyles(visible)">
    <a style="text-decoration: none" :href="`#${link.identification}`" v-for="link in myLinks" :key="link.guid" :ref="getLinkGuid(link.identification)">
      <div :style="getLinkStyles(link.identification)"
      >
        {{ link.text.getText(selectedLanguage) }}
      </div>
    </a>
  </div>
</template>

<script>
import BrowserBlock from './BrowserBlock.vue';

export default {
  name: 'scroll-browser-block',
  extends: BrowserBlock,
  created() {
    this.$store.dispatch('setScrollBrowserSelected', {
      clauseGuid: this.identification,
      sectionGuid: this.firstLinkGuid
    });
    const mappingClause = this.clauseGuidByListSectionGuid();
    this.$store.dispatch('setClauseGuidWithSectionsGuid', mappingClause);
  },
  computed: {
    selectedLinkId() {
      return this.$store.getters.getSrollBrowserSelected(this.identification);
    },
    firstLinkGuid() {
      const firstLink = this.myLinks[0];
      return firstLink ? firstLink.identification : '';
    },
  },
  methods: {
    clauseGuidByListSectionGuid() {
      return {
        [this.identification]: this.myLinks.map((each) => each.identification)
      };
    },
  },
};
</script>
